import moment from 'moment';

export function compareLastUpdatedDtPostedDtFileSinceDtSerialNumberDesc() {
  return (a, b) => {
    let comparison: number = moment(b.lastUpdatedDt).valueOf() - moment(a.lastUpdatedDt).valueOf();
    comparison = comparison === 0 ? moment(b.postedDt).valueOf() - moment(a.postedDt).valueOf() : comparison;
    comparison = comparison === 0 ? moment(b.fileSinceDt).valueOf() - moment(a.fileSinceDt).valueOf() : comparison;
    comparison = comparison === 0 ? b.serialNum - a.serialNum : comparison;
    return comparison;
  };
}

export function compareFileSinceDtLastUpdatedDtSerialNumberDesc() {
  return (a, b) => {
    let comparison: number = moment(b.fileSinceDt).valueOf() - moment(a.fileSinceDt).valueOf();
    comparison = comparison === 0 ? moment(b.lastUpdatedDt).valueOf() - moment(a.lastUpdatedDt).valueOf() : comparison;
    comparison = comparison === 0 ? b.serialNum - a.serialNum : comparison;
    return comparison;
  };
}

export function compareFiledDtLastUpdatedDtSerialNumberDesc() {
  return (a, b) => {
    let comparison: number = moment(b.filedDt).valueOf() - moment(a.filedDt).valueOf();
    comparison = comparison === 0 ? moment(b.lastUpdatedDt).valueOf() - moment(a.lastUpdatedDt).valueOf() : comparison;
    comparison = comparison === 0 ? b.serialNum - a.serialNum : comparison;
    return comparison;
  };
}

export function compareSerialDesc() {
  return (a, b) => b.serialNum - a.serialNum;
}

export function compareFileSinceDtDesc() {
  return (a, b) => moment(b.fileSinceDt).valueOf() - moment(a.fileSinceDt).valueOf();
}

export function compareAddrSinceDtDesc() {
  return (a, b) => moment(b.addrSinceDt).valueOf() - moment(a.addrSinceDt).valueOf();
}

export function compareInquiryDtDesc() {
  return (a, b) => moment(b.inquiryDt).valueOf() - moment(a.inquiryDt).valueOf();
}

export function compareTradeAcntRecencyDateAsc() {
  return (a, b) => moment(a.tradeAcntRecencyDate).valueOf() - moment(b.tradeAcntRecencyDate).valueOf();
}

export function compareTradeAcntRecencyDateDesc() {
  return (a, b) => moment(b.tradeAcntRecencyDate).valueOf() - moment(a.tradeAcntRecencyDate).valueOf();
}

export function compareLastSaleDateAsc() {
  return (a, b) => moment(a.lastSaleDate).valueOf() - moment(b.lastSaleDate).valueOf();
}

export function compareLastSaleDateDesc() {
  return (a, b) => moment(b.lastSaleDate).valueOf() - moment(a.lastSaleDate).valueOf();
}

export function compareDateReportedDesc() {
  return (a, b) => moment(b.dateReported).valueOf() - moment(a.dateReported).valueOf();
}
